export let ReservedCalendarSlug = /*#__PURE__*/function (ReservedCalendarSlug) {
  ReservedCalendarSlug["COMPLEX_NAVIGATION"] = "_select-date-time";
  return ReservedCalendarSlug;
}({});
//# sourceMappingURL=types.js.map